import React, { useState, useContext, useEffect } from "react";
import Input from "../input/Input";
import { useDispatch, useSelector } from "react-redux";
import { UserContext } from "../../stores/Context/Context";
import { language } from "../../stores/slices/languageSlice";
import validateInput from "../../utilities/validations/validateInput";
import { toast } from "react-toastify";
import DateInput from "../input/Date";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory from "react-bootstrap-table2-filter";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  searchProviderApi,
  getProviderAddressApi,
  addressTypes,
  updateProviderAddresses,
  TreatingPhysicianData,
  ProviderSearch,
  isNewProviderFalg,
  restTreatingPhysicianModalDetails,
  DateofDiagnosis,
  NationalProviderIdentifier,
  updateAddressesAppcreate,
  selectedTreatingPhysician,
  PatientsCurrentMedicationList,
  OtherMedicationText
} from "../../stores/slices/appIntake/searchProviderSlice";
import { DROPDOWN_STATES } from "../../constant/Constants";
import { Modal } from "antd";
import TreatingPhysicianModal from "./treatingPhysicianModal";
import { smartyStreetApi } from "../../stores/slices/smartyStreetSlice";
import { lookUp } from "../../stores/slices/lookupSlice";
import MultiSelect from "../input/MultiSelect";
import { formularyDetails } from "../../stores/slices/appIntake/formularyDetailsSlice";

function PatientMedical() {


  const DateofDiagnosisPrescreenValue = useSelector(state => state.preQualValidateSlice.success.preQualData.diagnosis)
  const preQualQuestionResponse = useSelector(state => state.preQualQuestionsSlice)

  const patientDetails = useSelector((state) => state.patientSearchSlice);
  const lookUpData = useSelector(lookUp);

  // get getProviderDetails data from store in searchProviderSlice
  const getProviderDetails = useSelector((state) => state.searchProviderSlice);

  // get ProviderAddresses data from store
  const ProviderAddresses =
    getProviderDetails?.searchProviderData?.ProviderAddresses;

  // get elementAddressType data from store
  const elementAddressType =
    getProviderDetails?.searchProviderData?.addressTypes;

  // get ProviderList data from store
  const ProviderList = getProviderDetails?.searchProviderData?.providerlist;

  // get treatingPhysicianModalDetails data from store
  const treatingPhysicianModalDetails =
    getProviderDetails?.searchProviderData?.treatingPhysicianModalDetails;

  // get preQualData from store in preQualValidateSlice
  const preQualData = useSelector(
    (state) => state.preQualValidateSlice.success.preQualData
  );

  const prgData = patientDetails.patientInformation.Program;
  let wizardValidation = useContext(UserContext);
  const dispatch = useDispatch();
  const selectedLanguage = useSelector(language).Appintake.medical;
  const errorMessage = useSelector(language).errorMessage;
  const [addNewFormData, setAddNewFormData] = useState({
    New_FirstName: { value: "", isValid: true },
    New_LastName: { value: "", isValid: true },
    New_AddressType: { value: "", isValid: true },
    New_AddressLine1: { value: "", isValid: true },
    New_suite: { value: "", isValid: true },
    New_city: { value: "", isValid: true },
    New_State: { value: "", isValid: true },
    New_zipcode: { value: "", isValid: true },
    New_fax: { value: "", isValid: true, errorMsg:false },
    New_PhoneNumber: { value: "", isValid: true, errorMsg:false },
    New_extension: { value: "", isValid: true },
    New_email: { value: "", isValid: true },
    New_officeContactName: { value: "", isValid: true },
    New_officeContactEmail: { value: "", isValid: true },
    smartyStreetMatches: {
      IsValid: false,
      NoMatch: false,
      PartialMatch: false,
      ExactMatch: false,
      SecInfoNotMatch: false,
    },
    ss_msg: "",
    ss_msg_cls: "",
    isAppAddressValid: false,
  });
  const [selected, updateSelected] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(true);
  const [isNewFormOpen, setIsNewFormOpen] = useState(false);
  const [searchProvider, setSearchProvider] = useState({
    firstName: { value: "", isValid: true },
    lastName: { value: "", isValid: true },
    city: { value: "", isValid: true },
    state: { value: "", isValid: true },
    zipCode: { value: "", isValid: true },
    Date_of_Diagnosis: { value: "", isValid: true },
    modalFirstName: "",
    modalLastName: "",
    AdditionalNames: "",
    AddressToDisplay: "",
    NationalProviderIdentifier: "",
  });

  const [selectedMedications, setSelectedMedications] = useState([]) 
  const [medicationOptions,setMedicationOptions] = useState([]) 
  const [isMedicationValid,setIsMedicationValid] = useState(true)
  const [otherMedicationText, setOtherMedicationText] = useState("")
  const [isOtherMedicationValid, setIsOtherMedicationValid] = useState(true)

  useEffect(() => {
    if (selectedMedications && selectedMedications.length > 0) {
      const otherItem = selectedMedications.find(m => m?.DrugName === "Other");
      if (otherItem) {
        setOtherMedicationText(getProviderDetails?.searchProviderData?.OtherMedicationText);
      } 
      else {
        setOtherMedicationText("");
      }
    } else {
      setOtherMedicationText("");
    }
  }, [selectedMedications]);

  const handleOtherMedicationChange = (e) => {
    const text = e.target.value;
    const textValue = text.trim().length > 0 ? text.trim() : "";
    setIsOtherMedicationValid(text.trim() !== "");
    const updatedSelected = (selectedMedications || []).map(m => {
      if (m?.DrugName === "Other") {
        return {
          ...m,
          DrugName: "Other"
        };
      }
      return m;
    });
    setOtherMedicationText(textValue);
    dispatch(OtherMedicationText(textValue));
  };
  
  const getFormularyData = async (searchText = "") => {
    const formularyData = await dispatch(formularyDetails({ prgData, fundId: preQualData.fundId, searchText }));
    const value = [];
    const uniqueValues = new Set();
    if (typeof formularyData?.payload?.pxResults !== "undefined" && formularyData?.payload?.pxResults.length > 0) {
      formularyData?.payload?.pxResults.forEach((data) => {
        if (typeof data.DrugName !== "undefined") {
          const val = `${data.DrugName}-${data.GenericName}`;
          if (!uniqueValues.has(val)) {
            uniqueValues.add(val);
            value.push({
              ...data,
              value: val,
            });
          }
        }
      });
    }
    const duplicates = value.filter(item => item.DrugName == "Other" );
    if(typeof duplicates !== "undefined" && duplicates.length == 0){
      value.push({
      "DrugName": "Other",
      "GenericName": "Other",
      "value" : "Other",
      "pxObjClass": "PAF-Data-Formulary"
    });
    }
    setMedicationOptions(value);
  }

  useEffect(() => {
    prgData == "CPR" && getFormularyData()
    setSearchProvider((prevState) => ({
      ...prevState,
      Date_of_Diagnosis: { value: getProviderDetails?.searchProviderData?.DateofDiagnosis || "", isValid: true }
    }))
    prgData == "CPR" && setSelectedMedications(getProviderDetails?.searchProviderData?.PatientsCurrentMedicationList)
    prgData == "CPR" && setOtherMedicationText(getProviderDetails?.searchProviderData?.OtherMedicationText)
    getProviderDetails?.searchProviderData?.TreatingPhysician?.pyFirstName && setIsNewFormOpen(true)
    setAddNewFormData((prevState) => ({
      ...prevState,
      New_FirstName: { value: getProviderDetails?.searchProviderData?.TreatingPhysician?.pyFirstName || "", isValid: true },
      New_LastName: { value: getProviderDetails?.searchProviderData?.TreatingPhysician?.pyLastName || "", isValid: true },
      New_AddressType: { value: getProviderDetails?.searchProviderData?.TreatingPhysician?.pyFirstName || "", isValid: true },
      New_AddressLine1: { value: getProviderDetails?.searchProviderData?.TreatingPhysician?.Address[0]?.AddressLine1 || "", isValid: true },
      New_suite: { value: getProviderDetails?.searchProviderData?.TreatingPhysician?.Address[0]?.Suite || "", isValid: true },
      New_city: { value: getProviderDetails?.searchProviderData?.TreatingPhysician?.Address[0]?.City || "", isValid: true },
      New_State: { value: getProviderDetails?.searchProviderData?.TreatingPhysician?.Address[0]?.State || "", isValid: true },
      New_zipcode: { value: getProviderDetails?.searchProviderData?.TreatingPhysician?.Address[0]?.ZipCode || "", isValid: true },
      New_fax: { value: getProviderDetails?.searchProviderData?.TreatingPhysician?.Address[0]?.Fax || "", isValid: true },
      New_PhoneNumber: { value: getProviderDetails?.searchProviderData?.TreatingPhysician?.Address[0]?.PhoneNumber || "", isValid: true },
      New_extension: { value: getProviderDetails?.searchProviderData?.TreatingPhysician?.Address[0]?.Extension || "", isValid: true },
      New_email: { value: getProviderDetails?.searchProviderData?.TreatingPhysician?.PhysicianEmailAddress || "", isValid: true },
      New_officeContactName: { value: getProviderDetails?.searchProviderData?.TreatingPhysician?.OfficeContactName || "", isValid: true },
      New_officeContactEmail: { value: getProviderDetails?.searchProviderData?.TreatingPhysician?.OfficeContactEmail || "", isValid: true },
    }))
    updateSelected(getProviderDetails?.searchProviderData?.selectedTreatingPhysician || [])
  }, [])

  const rowEvents = {
    onClick: (e, row) => {
      dispatch(restTreatingPhysicianModalDetails());
      setIsPopupOpen(true);
      // dispatch(updateProviderAddresses())
      let Address = row?.Address ? row.Address : [];
      dispatch(updateProviderAddresses(Address));
      let arr = [];
      setSearchProvider((preState) => ({
        ...preState,
        modalFirstName: row.pyFirstName ? row.pyFirstName : "",
        modalLastName: row.pyLastName ? row.pyLastName : "",
        AdditionalNames: row.AdditionalNames ? row.AdditionalNames : null,
        AddressToDisplay: row.AddressToDisplay ? row.AddressToDisplay : null,
        NationalProviderIdentifier: row.NationalProviderIdentifier
          ? row.NationalProviderIdentifier
          : null,
      }));
      dispatch(NationalProviderIdentifier(row.NationalProviderIdentifier));
      if (Address.length == 0) {
        let NPI = row.NationalProviderIdentifier;
        dispatch(getProviderAddressApi({ prgData: prgData, NPI }));
      }

      Address?.map((address, i) => {
        let value =
          address.Type +
          "(" +
          address.AddressLine1 +
          ", " +
          address.City +
          ", " +
          address.State +
          " - " +
          address.ZipCode +
          ")";
        let obj = { key: i, value: value };
        arr.push(obj);
      });
      dispatch(addressTypes(arr));
    },
  };

  // add new form open function
  const isNewFormOpenFunction = () => {
    setIsNewFormOpen(true);
  };

  // new form close function
  const isNewFormCloseFunction = () => {
    setIsNewFormOpen(false);
  };

  // new form onChange function
  const newInputOnChange = (e, fieldvalidation) => {
    let inputValue = e.target.value;
    let name = e.target.name;
    let inputValidate = validateInput(inputValue, fieldvalidation);
    if (
      name == "New_AddressLine1" ||
      name == "New_city" ||
      name == "New_zipcode" ||
      name == "New_State"
    ) {
      setAddNewFormData((prevState) => ({
        ...prevState,
        smartyStreetMatches: {
          IsValid: false,
          NoMatch: false,
          PartialMatch: false,
          ExactMatch: false,
          SecInfoNotMatch: false,
        },
        ss_msg: "",
        ss_msg_cls: "",
        isAppAddressValid: false,
      }));
    }
    if (name == 'New_officeContactEmail') {
      setAddNewFormData((prevState) => ({
        ...prevState,
        New_officeContactEmail: {
          value: inputValidate.value,
          isValid: inputValidate.value.length > 0 ? inputValidate.isValid : true,
        },
      }));
    }
    if(name == "New_fax" || name == "New_PhoneNumber"){
      setAddNewFormData((prevState) => ({
        ...prevState,
        [name]: {
          value: inputValidate.value,
          isValid: inputValidate.isValid,
          errorMsg:inputValidate.errorMsg
        },
      }));
    }else{
      setAddNewFormData((prevState) => ({
        ...prevState,
        [name]: {
          value: inputValidate.value,
          isValid: inputValidate.isValid,
        },
      }));
    }
  };

  // verify address function
  const verifyAddress = () => {
    let isFormValidation =
      addNewFormData.New_AddressLine1.value != "" &&
      addNewFormData.New_AddressLine1.isValid &&
      addNewFormData.New_city.value != "" &&
      addNewFormData.New_city.isValid &&
      addNewFormData.New_State.value != "" &&
      addNewFormData.New_State.isValid &&
      addNewFormData.New_zipcode.value != "" &&
      addNewFormData.New_zipcode.isValid;
    if (isFormValidation) {
      let address = {
        addressLine1: addNewFormData.New_AddressLine1.value,
        addressLine2: addNewFormData?.New_suite?.value,
        city: addNewFormData.New_city.value,
        state: addNewFormData.New_State.value,
        zipCode: addNewFormData.New_zipcode.value,
      };

      dispatch(smartyStreetApi({ address, callbackVerifiedAddress }));
    } else {
      setAddNewFormData((preState) => ({
        ...preState,
        New_AddressLine1: {
          value: addNewFormData.New_AddressLine1.value,
          isValid:
            addNewFormData.New_AddressLine1.value != "" &&
              addNewFormData.New_AddressLine1.isValid
              ? true
              : false,
        },
        New_State: {
          value: addNewFormData.New_State.value,
          isValid:
            addNewFormData.New_State.value != "" &&
              addNewFormData.New_State.isValid
              ? true
              : false,
        },
        New_city: {
          value: addNewFormData.New_city.value,
          isValid:
            addNewFormData.New_city.value != "" &&
              addNewFormData.New_city.isValid
              ? true
              : false,
        },
        New_zipcode: {
          value: addNewFormData.New_zipcode.value,
          isValid:
            addNewFormData.New_zipcode.value != "" &&
              addNewFormData.New_zipcode.isValid
              ? true
              : false,
        },
      }));
      toast.error(selectedLanguage?.toastError);
    }
  };

  const callbackVerifiedAddress = (address) => {
    if (
      address?.isValidateAddress != undefined &&
      address.isValidateAddress == "ExactMatch"
    ) {
      setAddNewFormData((prevState) => ({
        ...prevState,

        New_AddressLine1: {
          value: address.street,
          isValid: address.street != "" ? true : false,
        },
        New_city: {
          value: address.city,
          isValid: address.city != "" ? true : false,
        },
        New_State: {
          value: address.state,
          isValid: address.state != "" ? true : false,
        },
        New_zipcode: {
          value: address.zipcode,
          isValid: address.zipcode != "" ? true : false,
        },
        smartyStreetMatches: {
          IsValid: address.IsValid,
          NoMatch: address.NoMatch,
          PartialMatch: address.PartialMatch,
          ExactMatch: address.ExactMatch,
          SecInfoNotMatch: address.SecInfoNotMatch,
        },
        ss_msg: selectedLanguage?.verifyAddressSucces,
        ss_msg_cls: "ss_success",
        isAppAddressValid: true,
      }));
    } else {
      setAddNewFormData((preState) => ({
        ...preState,
        New_AddressLine1: {
          value: address.street,
          isValid: address.street != "" ? true : false,
        },
        New_city: {
          value: address.city,
          isValid: address.city != "" ? true : false,
        },
        New_State: {
          value: address.state,
          isValid: address.state != "" ? true : false,
        },
        New_zipcode: {
          value: address.zipcode,
          isValid: address.zipcode != "" ? true : false,
        },
        smartyStreetMatches: {
          IsValid: address.IsValid,
          NoMatch: address.NoMatch,
          PartialMatch: address.PartialMatch,
          ExactMatch: address.ExactMatch,
          SecInfoNotMatch: address.SecInfoNotMatch,
        },
        ss_msg: selectedLanguage?.verifyAddressError,
        ss_msg_cls: "ss_error",
        isAppAddressValid: false,
      }));
    }
  };

  function handleOnSelect(row, isSelect) {
    if (isSelect && row) {
      // updateSelected([row.NationalProviderIdentifier])
      updateSelected([row.NationalProviderIdentifier]);
      dispatch(selectedTreatingPhysician([row.NationalProviderIdentifier]))
    } else {
      return false;
    }
    return true;
  }
  function handleCheckboxChange() {
  }

  const btnReset = () => {
    setSearchProvider((preState) => ({
      ...preState,
      firstName: { value: "", isValid: true },
      lastName: { value: "", isValid: true },
      city: { value: "", isValid: true },
      state: { value: "", isValid: true },
      zipCode: { value: "", isValid: true },
    }));
  }

  // search function
  function btnSearch() {
    let searchValidationFields =
      (searchProvider.state.value != "" && searchProvider.state.isValid) ||
      (searchProvider.city.value != "" && searchProvider.city.isValid) ||
      (searchProvider.zipCode.value != "" && searchProvider.zipCode.isValid) ||
      (searchProvider.firstName.value &&
        searchProvider.firstName.isValid &&
        searchProvider.lastName.value &&
        searchProvider.lastName.isValid);
    if (searchValidationFields) {
      let provider = {
        City: searchProvider.city.value,
        State: searchProvider.state.value,
        FirstName: searchProvider.firstName.value,
        LastName: searchProvider.lastName.value,
        // FacilityPracticeName: FacilityPracticeNameSearch,
        // ProviderNPINbr: NPINumberSearch,
        pyPostalCode: searchProvider.zipCode.value,
        GroupingType: "1",
        Taxonomy: "",
      };
      dispatch(searchProviderApi({ prgData: prgData, provider }));
      setSearchProvider((preState) => ({
        ...preState,
        firstName: {
          value: searchProvider.firstName.value,
          isValid: true,
        },
        lastName: {
          value: searchProvider.lastName.value,
          isValid: true,
        },
        city: {
          value: searchProvider.city.value,
          isValid: true,
        },
        state: {
          value: searchProvider.state.value,
          isValid: true,
        },
        zipCode: {
          value: searchProvider.zipCode.value,
          isValid: true,
        },
      }));
    } else {
      setSearchProvider((preState) => ({
        ...preState,
        firstName: {
          value: searchProvider.firstName.value,
          isValid: searchProvider.firstName.value != "" ? true : false,
        },
        lastName: {
          value: searchProvider.lastName.value,
          isValid: searchProvider.lastName.value != "" ? true : false,
        },
        city: {
          value: searchProvider.city.value,
          isValid: searchProvider.city.value != "" ? true : false,
        },
        state: {
          value: searchProvider.state.value,
          isValid: searchProvider.state.value != "" ? true : false,
        },
        zipCode: {
          value: searchProvider.zipCode.value,
          isValid: searchProvider.zipCode.value != "" ? true : false,
        },
      }));
      toast.error("Fill in the mandatory fields");
    }
  }

  // let ProviderList = [
  //   {
  //     FullName: "ALYSSA MOSS",
  //     NationalProviderIdentifier: "1073981213",
  //     NPIType: "NPI-1",
  //     ProviderID: "1073981213",
  //     ProviderType: "1",
  //     pxObjClass: "PAF-Data-Provider",
  //     pyFirstName: "ALYSSA",
  //     pyLastName: "MOSS",
  //     UCASEFirstName: "ALYSSA",
  //     UCASELastName: "MOSS",
  //     AddressToDisplay: {
  //       AddressLine1: "2202 EXECUTIVE DR STE C",
  //       City: "HAMPTON",
  //       Fax: "757-838-2573",
  //       FullAddressLine: "2202 EXECUTIVE DR STE C",
  //       PhoneNumber: "757-827-7707",
  //       pxObjClass: "Embed-PegaHC-Address",
  //       State: "VA",
  //       ZipCode: "23666",
  //     },
  //   },
  // ];
  let column = [
    {
      dataField: "UCASEFirstName",
      text: "First Name",
      sort: true,
    },
    {
      dataField: "UCASELastName",
      text: "Last Name",
      sort: true,
    },
    {
      dataField: "AddressToDisplay.City",
      text: "City",
      sort: true,
    },
    {
      dataField: "AddressToDisplay.AddressLine1",
      text: "Address",
      sort: true,
    },
  ];
  let defaultSorted = [
    {
      dataField: "name",
      order: "desc",
    },
  ];
  let paginationOptions = {
    sizePerPage: 10,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  };
  const selectRow = {
    clickToSelect: true,
    selected: selected,
    hideSelectAll: true,
    onSelect: handleOnSelect,
    style: { backgroundColor: "#152C8C40" },
  };
  //validating new form input onChange
  const inputOnChange = (e, fieldvalidation, index) => {
    let inputValue = e.target.value;
    let name = e.target.name;
    let inputValidate = null;
    if(name == 'Date_of_Diagnosis'){
      inputValidate = validateInput(inputValue, fieldvalidation, patientDetails.patientInformation.dateOfBirth);
    }else {
      inputValidate = validateInput(inputValue, fieldvalidation);
    }
    

    setSearchProvider((prevState) => ({
      ...prevState,
      [name]: {
        value: inputValidate.value,
        isValid: inputValidate.isValid,
      },
    }));
  };

  // form validations function
  const isValidate = () => {
    let isFormValidate = false;
    if (!isNewFormOpen) {
      dispatch(isNewProviderFalg(isNewFormOpen));
      let ProvSearchCriteria = {
        FirstName: "",
        LastName: "",
        City: "",
        State: "",
        NPINumber: "",
        ZipCode: "",
      };
      dispatch(ProviderSearch(ProvSearchCriteria));
      let medicationValid = true
      if (prgData == "CPR") {
        const selectionValid = preQualData.fundGroup == "Default" && preQualQuestionResponse.DrugEnabled && typeof medicationOptions !== "undefined" ? selectedMedications.length > 0 : true;
        const hasOther = selectedMedications.some(m => m?.DrugName === "Other");
        const isOtherValid = !hasOther || (otherMedicationText && otherMedicationText.trim() !== "");
        setIsMedicationValid(selectionValid);
        setIsOtherMedicationValid(isOtherValid);
        medicationValid = selectionValid && isOtherValid;
        isFormValidate = isFormValidate && medicationValid;
      }
      if (
        ProviderList.length > 0 &&
        getProviderDetails?.searchProviderData?.noDataFlag &&
        searchProvider.Date_of_Diagnosis.value != "" &&
        searchProvider.Date_of_Diagnosis.isValid && medicationValid
      ) {
        dispatch(DateofDiagnosis(searchProvider.Date_of_Diagnosis.value));
        if (prgData == "CPR") {
          const selectionValid = preQualData.fundGroup == "Default" && preQualQuestionResponse.DrugEnabled && typeof medicationOptions !== "undefined" ? selectedMedications.length > 0 : true;
          const hasOther = selectedMedications.some(m => m?.DrugName === "Other");
          const isOtherValid = !hasOther || (otherMedicationText && otherMedicationText.trim() !== "");
          setIsMedicationValid(selectionValid);
          setIsOtherMedicationValid(isOtherValid);
          selectedMedications.length > 0 && dispatch(PatientsCurrentMedicationList(selectedMedications))
        }
        if (getProviderDetails?.searchProviderData?.isModalFormOpen) {
          let TreatingPhysician = {
            NationalProviderIdentifier:
              getProviderDetails?.searchProviderData
                ?.NationalProviderIdentifier,
            pxObjClass: "PAF-Data-Provider-Individual",
            Address: ProviderList,
          };
          dispatch(TreatingPhysicianData(TreatingPhysician));
          dispatch(updateAddressesAppcreate(ProviderAddresses))
          isFormValidate = true;
        } else {
          isFormValidate = false;
          toast.error("Select a provider from table");
        }
      } else {
        isFormValidate = isFormValidate && false
        setSearchProvider((preState) => ({
          ...preState,
          Date_of_Diagnosis: {
            value: searchProvider.Date_of_Diagnosis.value,
            isValid:
              searchProvider.Date_of_Diagnosis.value != "" &&
                searchProvider.Date_of_Diagnosis.isValid
                ? true
                : false,
          },
        }));
        toast.error(selectedLanguage?.toastError);
      }
      isFormValidate = isFormValidate && true;
      // new form validation
    } else {
      dispatch(isNewProviderFalg(isNewFormOpen));
      isFormValidate =
        addNewFormData.New_FirstName.value != "" &&
        addNewFormData.New_FirstName.isValid &&
        addNewFormData.New_LastName.value != "" &&
        addNewFormData.New_LastName.isValid &&
        addNewFormData.New_PhoneNumber.value != "" &&
        addNewFormData.New_PhoneNumber.isValid &&
        addNewFormData.New_fax.value != "" &&
        addNewFormData.New_fax.isValid &&
        addNewFormData.New_email.value != "" &&
        addNewFormData.New_email.isValid &&
        (addNewFormData.New_officeContactEmail.value != '' ? addNewFormData.New_officeContactEmail.isValid : true) &&
        addNewFormData.New_AddressLine1.value != "" &&
        addNewFormData.New_AddressLine1.isValid &&
        addNewFormData.New_AddressType.value != "" &&
        addNewFormData.New_AddressType.isValid &&
        addNewFormData.New_city.value != "" &&
        addNewFormData.New_city.isValid &&
        addNewFormData.New_State.value != "" &&
        addNewFormData.New_State.isValid &&
        addNewFormData.New_zipcode.value != "" &&
        addNewFormData.New_zipcode.isValid &&
        addNewFormData.New_officeContactName.value != "" && addNewFormData.New_officeContactName.isValid &&
        searchProvider.Date_of_Diagnosis.value != "" &&
        searchProvider.Date_of_Diagnosis.isValid;

      if (prgData == "CPR") {
        const selectionValid = preQualData.fundGroup == "Default" && preQualQuestionResponse.DrugEnabled && typeof medicationOptions !== "undefined" ? selectedMedications.length > 0 : true;
        const hasOther = selectedMedications.some(m => m?.DrugName === "Other");
        const isOtherValid = !hasOther || (otherMedicationText && otherMedicationText.trim() !== "");
        setIsMedicationValid(selectionValid);
        setIsOtherMedicationValid(isOtherValid);
        const medicationValid = selectionValid && isOtherValid;
        isFormValidate = isFormValidate && medicationValid;
      }

      if (isFormValidate) {
        let ProvSearchCriteria = {
            FullName:
          searchProvider.firstName.value + " " + searchProvider.lastName.value,
        NationalProviderIdentifier: "",
        NPIType: "1",
        pxObjClass: "PAF-Data-Provider-Individual",
        pxResultCount: ProviderList.length,
        pyCity: searchProvider.city.value,
        pyFirstName: searchProvider.firstName.value,
        pyLastName: searchProvider.lastName.value,
        pyPostalCode: searchProvider.zipCode.value,
        pyState: searchProvider.state.value,
        SearchedItem: "true",
        pxResults: ProviderList,
        };
        dispatch(ProviderSearch(ProvSearchCriteria));
        dispatch(DateofDiagnosis(searchProvider.Date_of_Diagnosis.value));
        prgData == "CPR" && selectedMedications.length > 0 && dispatch(PatientsCurrentMedicationList(selectedMedications))
        if (addNewFormData.ss_msg != "") {
          let TreatingPhysician = {
            NationalProviderIdentifier:
              getProviderDetails?.searchProviderData
                ?.NationalProviderIdentifier,
            pxObjClass: "PAF-Data-Provider-Individual",
            IsNewTreatingPhysician: "true",
            OfficeContactEmail: addNewFormData.New_officeContactEmail.value,
            OfficeContactName: addNewFormData.New_officeContactName.value,
            pyFirstName: addNewFormData.New_FirstName.value,
            pyLastName: addNewFormData.New_LastName.value,
            PhysicianEmailAddress: addNewFormData.New_email.value,
            Address: [
              {
                AddressLine1: addNewFormData.New_AddressLine1.value,
                AddressLine2: "",
                City: addNewFormData.New_city.value,
                Email: addNewFormData.New_email.value,
                Extension: addNewFormData.New_extension.value,
                Fax: addNewFormData.New_fax.value,
                PhoneNumber: addNewFormData.New_PhoneNumber.value,
                PreferredAddress: "true",
                pxObjClass: "Embed-PegaHC-Address",
                pySelected: "true",
                State: addNewFormData.New_State.value,
                Type: addNewFormData.New_AddressType.value,
                ZipCode: addNewFormData.New_zipcode.value,
                Suite: addNewFormData.New_suite.value,
                IsVerified: "true",
                IsValid: addNewFormData.smartyStreetMatches.IsValid,
                NoMatch: addNewFormData.smartyStreetMatches.NoMatch,
                PartialMatch: addNewFormData.smartyStreetMatches.PartialMatch,
                ExactMatch: addNewFormData.smartyStreetMatches.ExactMatch,
                SecInfoNotMatch:
                  addNewFormData.smartyStreetMatches.SecInfoNotMatch,
              },
            ],
          };
          dispatch(TreatingPhysicianData(TreatingPhysician));
          isFormValidate = true;
        } else {
          toast.error("Verify Treating Physician address to proceed");
          return false
        }
      } else {
        setAddNewFormData((preState) => ({
          ...preState,

          New_FirstName: {
            value: addNewFormData.New_FirstName.value,
            isValid:
              addNewFormData.New_FirstName.value != "" &&
                addNewFormData.New_FirstName.isValid
                ? true
                : false,
          },
          New_LastName: {
            value: addNewFormData.New_LastName.value,
            isValid:
              addNewFormData.New_LastName.value != "" &&
                addNewFormData.New_LastName.isValid
                ? true
                : false,
          },
          New_AddressType: {
            value: addNewFormData.New_AddressType.value,
            isValid:
              addNewFormData.New_AddressType.value != "" &&
                addNewFormData.New_AddressType.isValid
                ? true
                : false,
          },
          New_AddressLine1: {
            value: addNewFormData.New_AddressLine1.value,
            isValid:
              addNewFormData.New_AddressLine1.value != "" &&
                addNewFormData.New_AddressLine1.isValid
                ? true
                : false,
          },
          New_city: {
            value: addNewFormData.New_city.value,
            isValid:
              addNewFormData.New_city.value != "" &&
                addNewFormData.New_city.isValid
                ? true
                : false,
          },
          New_State: {
            value: addNewFormData.New_State.value,
            isValid:
              addNewFormData.New_State.value != "" &&
                addNewFormData.New_State.isValid
                ? true
                : false,
          },
          New_zipcode: {
            value: addNewFormData.New_zipcode.value,
            isValid:
              addNewFormData.New_zipcode.value != "" &&
                addNewFormData.New_zipcode.isValid
                ? true
                : false,
          },
          New_fax: {
            value: addNewFormData.New_fax.value,
            isValid:
              addNewFormData.New_fax.value != "" &&
                addNewFormData.New_fax.isValid
                ? true
                : false,
          },
          New_PhoneNumber: {
            value: addNewFormData.New_PhoneNumber.value,
            isValid:
              addNewFormData.New_PhoneNumber.value != "" &&
                addNewFormData.New_PhoneNumber.isValid
                ? true
                : false,
          },
          New_email: {
            value: addNewFormData.New_email.value,
            isValid:
              addNewFormData.New_email.value != "" &&
                addNewFormData.New_email.isValid
                ? true
                : false,
          },
          New_officeContactName: {
            value: addNewFormData.New_officeContactName.value,
            isValid: addNewFormData.New_officeContactName.value != "" && addNewFormData.New_officeContactName.isValid
          },
          New_officeContactEmail: {
            value: addNewFormData.New_officeContactEmail.value,
            isValid:
              addNewFormData.New_officeContactEmail.isValid
          },
        }));
        setSearchProvider((preState) => ({
          ...preState,
          Date_of_Diagnosis: {
            value: searchProvider.Date_of_Diagnosis.value,
            isValid:
              searchProvider.Date_of_Diagnosis.value != "" &&
                searchProvider.Date_of_Diagnosis.isValid
                ? true
                : false,
          },
        }));
        toast.error(selectedLanguage?.toastError);
      }
    }
    return isFormValidate;
  };
  wizardValidation.formValidation.isValidate = isValidate;
  return (
    <React.Fragment>
      {isNewFormOpen ? (
        <>
          <div className="text-center pt-8">
            <p className="fs-xl">{prgData == "CPR" ? selectedLanguage?.addYourTreatingPhysicianCPR : selectedLanguage?.addYourTreatingPhysician}</p>
            <br></br>
            <p>
              {selectedLanguage?.youCanAlsoTryToSearch}
              <span className="clickHere" onClick={isNewFormCloseFunction}>
                {" "}
                {selectedLanguage?.clickHereToSearch}
              </span>
            </p>
          </div>
          <div className="grid columns-12 gap-4 gap-y-0 mt-0 pb-8 mb-5">
            <Input
              type="text"
              id="New_FirstName"
              label={selectedLanguage?.firstName}
              name="New_FirstName"
              value={addNewFormData.New_FirstName.value}
              isValid={addNewFormData.New_FirstName.isValid}
              onChange={(e) => newInputOnChange(e, "firstName")}
              errorMsg={errorMessage?.inputErrorMessage}
              maxLength="30"
            />
            <Input
              type="text"
              id="New_LastName"
              label={selectedLanguage?.lastName}
              name="New_LastName"
              value={addNewFormData.New_LastName.value}
              isValid={addNewFormData.New_LastName.isValid}
              onChange={(e) => newInputOnChange(e, "lastName")}
              errorMsg={errorMessage?.inputErrorMessage}
              maxLength="30"
            />
            <Input
              type="select"
              id="New_AddressType"
              label={selectedLanguage?.addressType}
              name="New_AddressType"
              value={addNewFormData.New_AddressType.value}
              isValid={addNewFormData.New_AddressType.isValid}
              onChange={(e) => newInputOnChange(e, "address")}
              errorMsg={errorMessage?.inputErrorMessage}
              elmentconfig={lookUpData.physicianAddressType}
            />
            <Input
              type="text"
              id="New_AddressLine1"
              label={selectedLanguage?.addressLine1}
              name="New_AddressLine1"
              value={addNewFormData.New_AddressLine1.value}
              isValid={addNewFormData.New_AddressLine1.isValid}
              onChange={(e) => newInputOnChange(e, "traetingAddress")}
              errorMsg={errorMessage?.inputErrorMessage}
              maxLength="100"
            />
            <Input
              type="text"
              id="New_suite"
              label={selectedLanguage?.suite}
              name="New_suite"
              value={addNewFormData.New_suite.value}
              isValid={addNewFormData.New_suite.isValid}
              onChange={(e) => newInputOnChange(e, "address")}
              errorMsg={errorMessage?.inputErrorMessage}
              elmentconfig={DROPDOWN_STATES}
              maxLength="100"
            />
            <Input
              type="text"
              id="New_city"
              label={selectedLanguage?.city}
              name="New_city"
              value={addNewFormData.New_city.value}
              isValid={addNewFormData.New_city.isValid}
              onChange={(e) => newInputOnChange(e, "city")}
              errorMsg={errorMessage?.inputErrorMessage}
              maxLength="50"
            />
            <Input
              type="select"
              id="New_State"
              label={selectedLanguage?.state}
              name="New_State"
              value={addNewFormData.New_State.value}
              isValid={addNewFormData.New_State.isValid}
              onChange={(e) => newInputOnChange(e, "state")}
              errorMsg={errorMessage?.inputErrorMessage}
              elmentconfig={DROPDOWN_STATES}
            />
            <Input
              type="text"
              id="New_zipcode"
              label={selectedLanguage?.zipcode}
              name="New_zipcode"
              value={addNewFormData.New_zipcode.value}
              isValid={addNewFormData.New_zipcode.isValid}
              onChange={(e) => newInputOnChange(e, "zipcode")}
              errorMsg={errorMessage?.inputErrorMessage}
              maxLength={"5"}
            />
            <Input
              type="text"
              id="New_fax"
              label={selectedLanguage?.fax}
              name="New_fax"
              value={addNewFormData.New_fax.value}
              isValid={addNewFormData.New_fax.isValid}
              onChange={(e) => newInputOnChange(e, "phoneNumber")}
              errorMsg={addNewFormData.New_fax.errorMsg  ?  "Phone/Fax number cannot begin with the number one" : errorMessage?.inputErrorMessage}
              maxLength={"12"}
            />
            <Input
              type="text"
              id="New_PhoneNumber"
              label={selectedLanguage?.phoneNumber}
              name="New_PhoneNumber"
              value={addNewFormData.New_PhoneNumber.value}
              isValid={addNewFormData.New_PhoneNumber.isValid}
              onChange={(e) => newInputOnChange(e, "phoneNumber")}
              maxLength="12"
              errorMsg={addNewFormData.New_PhoneNumber.errorMsg  ?  "Phone/Fax number cannot begin with the number one" : errorMessage?.inputErrorMessage}
            />
            <Input
              type="text"
              id="New_extension"
              label={selectedLanguage?.extension}
              name="New_extension"
              value={addNewFormData.New_extension.value}
              isValid={addNewFormData.New_extension.isValid}
              onChange={(e) => newInputOnChange(e, "ext")}
              errorMsg={errorMessage?.inputErrorMessage}
              maxLength="10"
            />
            <Input
              type="text"
              id="New_email"
              label={selectedLanguage?.email}
              name="New_email"
              value={addNewFormData.New_email.value}
              isValid={addNewFormData.New_email.isValid}
              onChange={(e) => newInputOnChange(e, "email")}
              errorMsg={errorMessage?.inputErrorMessage}
              maxLength="100"
            />
            <Input
              type="text"
              id="New_officeContactName"
              label={selectedLanguage?.officeContactName}
              name="New_officeContactName"
              value={addNewFormData.New_officeContactName.value}
              isValid={addNewFormData.New_officeContactName.isValid}
              onChange={(e) => newInputOnChange(e, "name")}
              errorMsg={errorMessage?.inputErrorMessage}
              maxLength="100"
            />
            <Input
              type="text"
              id="New_officeContactEmail"
              label={selectedLanguage?.officeContactEmail}
              name="New_officeContactEmail"
              value={addNewFormData.New_officeContactEmail.value}
              isValid={addNewFormData.New_officeContactEmail.isValid}
              onChange={(e) => newInputOnChange(e, "email")}
              errorMsg={errorMessage?.inputErrorMessage}
              maxLength="100"
            />
          </div>

          <div className="text-center">
            <div className={`pb-2 ${addNewFormData.ss_msg_cls}`}>
              {addNewFormData.ss_msg}
            </div>
            <button className="btn btn-yellow fs-base " onClick={verifyAddress}>
              <p class="px-3">{selectedLanguage?.verifyAdreesBtn}</p>
            </button>
          </div>
        </>
      ) : (
        <>
          <div className="text-center pt-8 pb-8">
            <p className="fs-2xl">{prgData == "CPR" ? selectedLanguage.searchTreatingPhysicianCPR : selectedLanguage.searchTreatingPhysician}</p>
            <p className="pt-3">{prgData == "CPR" ? selectedLanguage.stateandCityCPR : selectedLanguage.stateandCity}</p>
            <p className="pt-3">{selectedLanguage.additionalInfo}</p>
            {/* <p className="pt-3">Press the Tab Key to start your search.{selectedLanguage.searchTreatingPhysician}</p> */}
          </div>
          <div className="grid columns-12 gap-4 gap-y-0 mt-0 pb-8 mb-5 border search_form">
            <Input
              type="select"
              id="state"
              label={selectedLanguage.state}
              name="state"
              value={searchProvider.state.value}
              isValid={searchProvider.state.isValid}
              onChange={(e) => inputOnChange(e, "state")}
              errorMsg={errorMessage?.inputErrorMessage}
              elmentconfig={lookUpData.State}
            />
            <Input
              type="text"
              id="city"
              label={selectedLanguage.city}
              name="city"
              value={searchProvider.city.value}
              isValid={searchProvider.city.isValid}
              onChange={(e) => inputOnChange(e, "city")}
              errorMsg={errorMessage?.inputErrorMessage}
              maxLength="50"
            />
            <Input
              type="text"
              id="firstName"
              label={selectedLanguage.firstName}
              name="firstName"
              value={searchProvider.firstName.value}
              isValid={searchProvider.firstName.isValid}
              onChange={(e) => inputOnChange(e, "firstName")}
              errorMsg={errorMessage?.inputErrorMessage}
              maxLength="30"
            />
            <Input
              type="text"
              id="lastName"
              label={selectedLanguage.lastName}
              name="lastName"
              value={searchProvider.lastName.value}
              isValid={searchProvider.lastName.isValid}
              onChange={(e) => inputOnChange(e, "lastName")}
              errorMsg={errorMessage?.inputErrorMessage}
              maxLength="30"
            />
            <Input
              type="text"
              id="zipcode"
              label={selectedLanguage.zipcode}
              name="zipCode"
              value={searchProvider.zipCode.value}
              isValid={searchProvider.zipCode.isValid}
              onChange={(e) => inputOnChange(e, "zipcode")}
              errorMsg={errorMessage?.inputErrorMessage}
              maxLength={"5"}
            />
            <div className="intro-y g-col-12 g-col-md-6 g-col-sm-6 g-col-xl-4 px-8 pt-6 text-center d-flex justify-content-center">
              <button className="btn btn-yellow fs-base reset-btn " onClick={btnReset}>
                <p class="px-3">{selectedLanguage?.reset}</p>
              </button>
              <button className="btn btn-yellow fs-base reset-btn ms-3" onClick={btnSearch}>
                <p class="px-3">{selectedLanguage?.search}</p>
              </button>
            </div>
          </div>
        <div className="text-center p-3">
            <p className="fs-2xl">{prgData == "CPR" ? selectedLanguage?.selectYourTreatingPhysicianCPR : selectedLanguage?.selectYourTreatingPhysician}</p>
              {getProviderDetails.searchProviderData.noDataFlag && <p className="pt-5 pb-3">
              {prgData == "CPR" ? selectedLanguage?.selectYourTreatingPhysicianCantentCPR :selectedLanguage?.selectYourTreatingPhysicianCantent}
                <span className="clickHere" onClick={isNewFormOpenFunction}>
                {" "}
                {selectedLanguage?.clickHeretoAdd}
              </span>
              </p>}
          </div>
          <BootstrapTable
            bootstrap4
            keyField="NationalProviderIdentifier"
            data={ProviderList}
            columns={column}
            defaultSorted={defaultSorted}
            filter={filterFactory()}
            pagination={paginationFactory(paginationOptions)}
            hover
            selectRow={selectRow}
            classes="provider-search"
            noDataIndication={
              ProviderList.length < 1 &&
                getProviderDetails?.searchProviderData?.noDataFlag ? (
                <p style={{ fontSize: "14px" }}>
                  {prgData == "CPR" ? selectedLanguage?.couldNotFindYourPhysicianCPR : selectedLanguage?.couldNotFindYourPhysician}{" "}
                  <a
                    style={{ color: "#2CA8FF", cursor: "pointer" }}
                    onClick={isNewFormOpenFunction}
                  >
                    {selectedLanguage?.clickHeretoAdd}
                  </a>{" "}
                </p>
              ) : (
                `${prgData == "CPR" ? selectedLanguage?.pleaseEnterStateAndCityToSearchYourTPCPR : selectedLanguage?.pleaseEnterStateAndCityToSearchYourTP}`
              )
            }
            rowEvents={rowEvents}
          />
          {!!getProviderDetails?.searchProviderData?.isModalFormOpen ? (
            <>
              <div className="text-center px-8 pb-3 pt-4">
                <p className="fs-xl">{prgData == "CPR" ? selectedLanguage?.selectTreatingPhysicianCPR : selectedLanguage?.selectTreatingPhysician}</p>
              </div>
              <div class="grid input-fields columns-12 gap-4 gap-y-5 p-8 mb-5 container ">
                <div className="intro-y g-col-12 g-col-md-4 g-col-xl-4 ms-8">
                  <b>First name</b>
                  <br></br>
                  <p>{treatingPhysicianModalDetails?.firstName}</p>
                </div>
                <div className="intro-y g-col-12 g-col-md-4 g-col-xl-4 ms-8">
                  <b>Last name</b>
                  <br></br>
                  <p>{treatingPhysicianModalDetails?.lastName}</p>
                </div>
                <div className="intro-y g-col-12 g-col-md-4 g-col-xl-4 ms-8">
                  <b>NPI Number</b>
                  <br></br>
                  <p>{searchProvider.NationalProviderIdentifier}</p>
                </div>
                <div className="intro-y g-col-12 g-col-md-4 g-col-xl-4 ms-8">
                  <b>AddressType</b>
                  <br></br>
                  <p>{treatingPhysicianModalDetails?.address_Type}</p>
                </div>
                <div className="intro-y g-col-12 g-col-md-4 g-col-xl-4 ms-8">
                  <b>Address Line 1</b>
                  <br></br>
                  <p>{treatingPhysicianModalDetails?.Address_Line1}</p>
                </div>
                <div className="intro-y g-col-12 g-col-md-4 g-col-xl-4 ms-8">
                  <b>Address Line 2</b>
                  <br></br>
                  <p>
                    {treatingPhysicianModalDetails?.Address_Line2 !=
                      undefined &&
                      treatingPhysicianModalDetails?.Address_Line2 != ""
                      ? treatingPhysicianModalDetails?.Address_Line2
                      : "--"}
                  </p>
                </div>
                <div className="intro-y g-col-12 g-col-md-4 g-col-xl-4 ms-8">
                  <b>City</b>
                  <br></br>
                  <p>{treatingPhysicianModalDetails.City}</p>
                </div>
                <div className="intro-y g-col-12 g-col-md-4 g-col-xl-4 ms-8">
                  <b>State</b>
                  <br></br>
                  <p>{treatingPhysicianModalDetails.State}</p>
                </div>
                <div className="intro-y g-col-12 g-col-md-4 g-col-xl-4 ms-8">
                  <b>Zip Code</b>
                  <br></br>
                  <p>{treatingPhysicianModalDetails.Zip_Code}</p>
                </div>
                <div className="intro-y g-col-12 g-col-md-4 g-col-xl-4 ms-8">
                  <b>Phone Number</b>
                  <br></br>
                  <p>{treatingPhysicianModalDetails.Phone_Number}</p>
                </div>
                <div className="intro-y g-col-12 g-col-md-4 g-col-xl-4 ms-8">
                  <b>Fax</b>
                  <br></br>
                  <p>{treatingPhysicianModalDetails.fax}</p>
                </div>
              </div>
            </>
          ) : (
            ""
          )}
        </>
      )}

      <div className="text-center pt-8">
        <p className="fs-xl">{selectedLanguage.primaryDiagnosis}</p>
      </div>
      <div class="grid input-fields columns-12 gap-4 gap-y-5 p-8 mb-5 container ">
        <div className="intro-y g-col-12 g-col-md-6 g-col-xl-6 ms-8 text-center">
          <p>
            {" "}
            <b> {selectedLanguage?.primaryDiagnosis}</b> <br></br>{DateofDiagnosisPrescreenValue}{" "}
            <br></br>
            {/* {selectedLanguage?.hypercholesterolemia} */}
          </p>
        </div>
        {preQualData.fundGroup != "Testing" ? (
          <div className="intro-y g-col-12 g-col-md-6 g-col-xl-6 ms-0">
            <DateInput
              type="date"
              id="Date_of_Diagnosis"
              label={selectedLanguage.DOD}
              name="Date_of_Diagnosis"
              value={searchProvider.Date_of_Diagnosis.value}
              isValid={searchProvider.Date_of_Diagnosis.isValid}
              onChange={(e) => inputOnChange(e, "dateOfDiagnosis")}
              errorMsg={errorMessage?.inputErrorMessage}
              elmentconfig={DROPDOWN_STATES}
            // disabled={true}
            />
          </div>
        ) : (
          <div className="intro-y g-col-12 g-col-md-6 g-col-xl-6 ms-0">
            <DateInput
              actualDate={true}
              type="date"
              id="Date_of_Diagnosis"
              label={selectedLanguage.actualDOD}
              name="Date_of_Diagnosis"
              value={searchProvider.Date_of_Diagnosis.value}
              isValid={searchProvider.Date_of_Diagnosis.isValid}
              onChange={(e) => inputOnChange(e, "dateOfDiagnosis_test")}
              errorMsg={errorMessage?.inputErrorMessage}
              elmentconfig={DROPDOWN_STATES}
            // disabled={true}
            />
          </div>
        )}
      </div>
      <br/>
      {prgData == "CPR" && preQualQuestionResponse.DrugEnabled && preQualData.fundGroup == "Default" && <>
          <div className="row align-items-center">
            <div className="col-md-1"></div>
            <div className="col-md-10">
              <h4 className="info-text fs-xl">Patient’s Current Medication (Related to Diagnosis)</h4>
          </div>
            <div className="col-md-1"></div>
            <div className="col-md-1"></div>
            <div className="col-md-10 mt-3 mb-3">
              The TotalAssist grant can only be used for co-pays, co-insurance, or deductibles for medications covered by the fund, as well as certain treatment-related expenses and eligible medical or prescription insurance premiums. A complete list of medications covered by each fund is available at TotalAssist.org. If a medication does not appear on the list, it is not covered by the program.
              <br />
              <br />
              Please enter all medications the patient is currently taking for this diagnosis. Begin typing the name of each medication, then select the correct medication from the drop-down list that appears.
              <br />
              <br />
              If the patient is not currently taking a medication but is applying for insurance premium assistance only, type Insurance and select it from the drop-down list.
            </div>
            <div className="col-md-1"></div>
          </div>
          <div className="row mt-4">
            <div className="col-md-1"></div>
            <div className="col-md-10">
              <MultiSelect
                label="Patient's Current Medications (Related to Diagnosis)"
                options={medicationOptions || []}
                selected={selectedMedications || []}
                placeholder="Select medications..."
                isValid={isMedicationValid}
                errorMsg="Please select or input a valid value"
                onChange={(selected) => {
                  dispatch(PatientsCurrentMedicationList(selected))
                  setSelectedMedications(selected)
                  setIsMedicationValid(selected.length > 0)
                }}
                onInputChange={(searchText) => {
                  getFormularyData(searchText)
                }}
              />
            </div>
            <div className="col-md-1"></div>
          </div>
          {selectedMedications && selectedMedications.some(m => m?.DrugName === "Other") && (
            <div className="row mt-4">
              <div className="col-md-1"></div>
              <div className="col-md-6">
                <Input
                  type="text"
                  id="OtherMedication"
                  label="Other Drug Name"
                  name="OtherMedication"
                  value={otherMedicationText}
                  isValid={isOtherMedicationValid}
                  onChange={handleOtherMedicationChange}
                  errorMsg="Please specify the medication name"
                />
              </div>
              <div className="col-md-1"></div>
            </div>
          )}
        </>
        }
      <Modal
        visible={isPopupOpen && searchProvider.NationalProviderIdentifier != ""}
        // title=''
        cancelButtonProps={{ style: { display: "none" } }}
        okButtonProps={{ style: { display: "none" } }}
        // className='myModal'
        maskClosable={false}
        closable={false}
        width={850}
        centered
      >
        <TreatingPhysicianModal
          setIsPopupOpen={setIsPopupOpen}
          searchProvider={searchProvider}
        />
      </Modal>
      {/* <button onClick={isValidate}>NEXT</button> */}
    </React.Fragment>
  );
}

export default PatientMedical;
